export default __webpack_public_path__ + "static/media/Leo160.52180126.jpg";